import { IconButton } from '@mui/material';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { TagType, TagValue } from 'lib/types/tags';
import { SingleCreatableTagValueSearch } from 'components/TagValueSearch/SingleCreatableTagValueSearch';
import { ucFirst } from 'lib/helpers';

interface Props {
  tagType: TagType;
  onSelectTag: (tagValue: TagValue) => void;
  onCancelAddTag: () => void;
  postId?: number;
  skipSaveOnSelect?: boolean;
}

export const TagValueForm = (props: Props) => {
  const {
    tagType, onSelectTag, onCancelAddTag, postId, skipSaveOnSelect = false,
  } = props;
  return (
    <div className="flex items-center">
      <div className="w-48">
        <SingleCreatableTagValueSearch
          tagTypeId={tagType.id}
          onSelectTag={onSelectTag}
          label={ucFirst(tagType.name)}
          postId={postId}
          skipSaveOnSelect={skipSaveOnSelect}
        />
      </div>
      <IconButton
        color="primary"
        aria-label="cancel add tag"
        value={tagType.id}
        onClick={onCancelAddTag}
        size="large"
      >
        <CloseRounded color="primary" fontSize="small" />
      </IconButton>
    </div>
  );
};
